import React, { useEffect, useState } from "react";
import "./WebsiteUrl.css";
import { RiInformationFill } from "react-icons/ri";
import { Input, Button, Form, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { workspaces_List_ActionHandler } from "../../../../../Redux/Actions/user/WorkspacesList";
import { workspaces_Support_Documents_ActionHandler } from "../../../../../Redux/Actions/user/WorkspaceSupportingDocumentList";
import {
  CreateSupportingDocumentsActionHandler,
  clearDocumentsSupportingData,
} from "../../../../../Redux/Actions/user/BuildQuickCreateSupportingDocumentsAction";
const { TextArea } = Input;
const { Option } = Select;
const WebsiteUrl = ({
  workspaceFolderFlag,
  workspace_id,
  folder_id,
  name,
  context,
  handleCreateSupportDocument,
  handleSupportingDocumentButtonClick,
  workspaceId_uc,
  workspaceByIdStatus,
}) => {
  let dispatch = useDispatch();
  const [workspaceId, setWorkspaceId] = useState(null);
  const [topDomain, setTopDomain] = useState("");
  const [singleUrl, setSingleUrl] = useState("");
  const [excludeUrl, setExcludeUrl] = useState("");
  const [Frequency, setFrequency] = useState("");
  const [isValidtion, setIsValidtion] = useState(false);
  const [nameByUrl, setNameByUrl] = useState("");
  const formRef = React.createRef();
  const workspaceData = useSelector(
    (state) => state?.workspaces_List_Data?.workspace_create_data?.data
  );
  const workspaceFolderListData = useSelector(
    (state) =>
      state?.workspaces_Supporting_Document_FolderList_Data
        ?.workspace_supporting_documentlist_data?.data
  );
  const documentssupportingcreatewebsiteurldata = useSelector(
    (state) =>
      state?.BuildQuickCreateSupportingDocumentsData
        ?.documents_supporting_create_data
  );
  const onFinish = (values) => {
    // if (!values.exclude_urls && !values.single_url) {
    //   setIsValidtion(true);
    //   return;
    // }
    // setIsValidtion(false);
    if (workspace_id) {
      workspace_id = workspace_id;
    } else {
      workspace_id = values.workspace_id;
    }
    if (folder_id) {
      folder_id = folder_id;
    } else {
      folder_id = values.folder_id;
    }
    let exclude_urls = [];
    if (values.exclude_urls) {
      exclude_urls = [values.exclude_urls];
    }
    const submitObject = {
      workspace_id: parseInt(workspace_id, 10),
      folder_id: parseInt(folder_id, 10),
      name: values.name,
      context: "This is the " + values.name + ":",
      type: "url",
      top_domain: values.top_domain,
      exclude_urls: exclude_urls,
      single_url: values.single_url,
      frequency: values.frequency,
      data: values.data,
    };
    dispatch(CreateSupportingDocumentsActionHandler(submitObject));
  };
  const handleChangeWorkspace = (value) => {
    formRef.current.resetFields(["folder_id"]);
    setWorkspaceId(value);
  };
  useEffect(() => {
    if (workspaceId) {
      dispatch(workspaces_Support_Documents_ActionHandler(workspaceId, "", ""));
    }
  }, [workspaceId]);
  useEffect(() => {
    if (workspaceId_uc || workspaceByIdStatus) {
      dispatch(
        workspaces_Support_Documents_ActionHandler(
          workspaceId_uc || workspaceByIdStatus,
          "",
          ""
        )
      );
    }
  }, [workspaceId_uc, workspaceByIdStatus]);

  useEffect(() => {
    dispatch(workspaces_List_ActionHandler("", ""));
  }, []);
  useEffect(() => {
    if (documentssupportingcreatewebsiteurldata) {
      handleCreateSupportDocument(false);
      handleSupportingDocumentButtonClick(false);
      dispatch(clearDocumentsSupportingData());
    }
  }, [documentssupportingcreatewebsiteurldata, dispatch]);
  const validateMessages = {
    required: "Please input your ${label}!",
    types: {
      name: "Please enter a valid name",
    },
  };

  const handleTopDomainChange = (e) => {
    setTopDomain(e.target.value);
    setExcludeUrl(e.target.value);
  };

  const handleSingleUrlChange = (e) => {
    setSingleUrl(e.target.value);
    setFrequency(e.target.value);
    setNameByUrl(e.target.value);
  };

  const handleFormChange = (changedFields, allFields) => {
    const changedField = changedFields[0];

    if (changedField) {
      const fieldName = Array.isArray(changedField.name)
        ? changedField.name[0]
        : changedField.name;
      if (fieldName === "name") {
        formRef.current.setFieldsValue({
          ["context"]: "This is the " + changedField.value + ":",
        });
      }
    }
  };

  const isTopDomainFilled = topDomain !== "";
  const isExcludeUrl = excludeUrl !== "";
  const isFrequency = Frequency !== "";
  const isSingleUrlFilled = singleUrl !== "";

  useEffect(() => {
    if (nameByUrl) {
      const regex = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/;
      formRef.current.setFieldsValue({
        name: `${name} ${nameByUrl.match(regex)[1]}`,
      });
    }
  }, [nameByUrl]);

  return (
    <>
      <Form
        name="uploadComputerForm"
        initialValues={{
          name: name,
          context: "This is the " + name + ":",
          top_domain: "",
          exclude_urls: "",
          workspace_id: workspaceId_uc,
          single_url: "",
          foler_id: "",
          frequency: "",
          data: "",
        }}
        onFieldsChange={handleFormChange}
        ref={formRef}
        validateMessages={validateMessages}
        onFinish={onFinish}
      >
        <div className="supporting-document-1">
          <label>Supporting document name</label>
          <Form.Item
            name="name"
            rules={[
              {
                required: true,
                message: "Please input your name!",
              },
              {
                type: "name",
                message: "Please enter a valid name",
              },
            ]}
          >
            <Input placeholder="Enter your name" />
          </Form.Item>
        </div>
        {/* <div className="supporting-document-2">
          <label>Context to frame reference data (edit if required)</label>
          <Form.Item
            name="context"
            rules={[
              {
                required: true,
                message: "Please input your context!",
              },
              {
                type: "name",
                message: "Please enter a valid context",
              },
            ]}
          >
            <Input placeholder="Enter your context" />
          </Form.Item>
        </div> */}
        <div className="website-url-modal-div">
          <h3>Live reference data</h3>
          <label>Set-up URL to monitor</label>
        </div>
        <div className="website-url-input">
          <div className="website-url-1">
            <label>Scrape a website using the Top Level Domain</label>
            <Form.Item
              name="top_domain"
              rules={[
                {
                  required: !isSingleUrlFilled,
                  message: "Please input your top_domain!",
                },
              ]}
            >
              <Input
                placeholder="Enter your top_domain"
                onChange={handleTopDomainChange}
              />
            </Form.Item>
          </div>
          <div className="website-url-2">
            <label>
              List any URLs you do not want to scrape on this website
            </label>
            <Form.Item
              name="exclude_urls"
              rules={[
                {
                  required: false,
                  message: "Please input your exclude_urls!",
                },
              ]}
            >
              <Input
                placeholder="Enter your exclude_urls"
                onChange={(e) => setNameByUrl(e.target.value)}
              />
            </Form.Item>
          </div>
        </div>
        <div className="website-url-modal-div">
          <h3>Or</h3>
        </div>
        <div className="website-url-input">
          <div className="website-url-1">
            <label>Scrape a single URL</label>
            <Form.Item
              name="single_url"
              rules={[
                {
                  required: !isTopDomainFilled,
                  message: "Please input your single_url!",
                },
              ]}
            >
              <Input
                placeholder="Enter your single_url"
                onChange={handleSingleUrlChange}
              />
            </Form.Item>
          </div>
          {isValidtion ? (
            <p style={{ color: "#ff4d4f", fontSize: "14px" }}>
              Please Enter Exclude Urls OR Single Url{" "}
            </p>
          ) : null}
          <div className="website-url-2">
            <label>Frequency</label>
            <Form.Item
              name="frequency"
              rules={[
                {
                  required: !isExcludeUrl,
                  message: "Please select the frequency!",
                },
              ]}
            >
              <Select
                className="Frequency"
                options={[
                  { value: "off", label: "off" },
                  { value: "once", label: "once" },
                  { value: "quarterly", label: "quarterly" },
                  { value: "monthly", label: "monthly" },
                  { value: "weekly", label: "weekly" },
                  { value: "daily", label: "daily" },
                ]}
              />
            </Form.Item>
          </div>
        </div>

        {workspaceFolderFlag ? null : (
          <>
            <div className="website-url-modal-div">
              <h3>Select Destination Directory</h3>
            </div>
            <div className="website-url-input">
              {!workspaceByIdStatus && (
                <div className="website-url-1">
                  <label>Select Workspace</label>
                  <Form.Item
                    name="workspace_id"
                    rules={[
                      {
                        required: true,
                        message: "Please select a workspace!",
                      },
                    ]}
                  >
                    <Select
                      className="uploadcomputer-select"
                      onChange={handleChangeWorkspace}
                    >
                      {workspaceData &&
                        workspaceData.map((workspace) => (
                          <>
                            {!workspace.is_locked && (
                              <Option key={workspace.id} value={workspace.id}>
                                {workspace.name}
                              </Option>
                            )}
                          </>
                        ))}
                    </Select>
                  </Form.Item>
                </div>
              )}
              <div className="website-url-2">
                <label>Select Folder</label>
                <Form.Item
                  name="folder_id"
                  rules={[
                    {
                      required: true,
                      message: "Please select a folder!",
                    },
                  ]}
                >
                  <Select className="uploadcomputer-select" name="folder_id">
                    {workspaceFolderListData &&
                      workspaceFolderListData.map((folder) => (
                        <Option key={folder.id} value={folder.id}>
                          {folder.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </div>
            </div>
          </>
        )}
        <div className="website-url-2">
          <label>Reference data</label>
          <Form.Item
            name="data"
            rules={[
              {
                required: false,
                message: "Please select the data!",
              },
            ]}
          >
            <TextArea rows={4} disabled />
          </Form.Item>
        </div>
        <div className="website-url-main-content">
          <div className="website-url-flex">
            <RiInformationFill className="website-url-info-svg" />
            <p>
              Creating live reference data can take time. Your live reference
              date can be found in the workspace you have saved it to. It will
              be displayed as processing until the data scraping is completed.
            </p>
          </div>
        </div>
        <div className="upload-website-url-div">
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              className="upload-website-url-button"
            >
              Create Supporting Document
            </Button>
          </Form.Item>
        </div>
      </Form>
    </>
  );
};
export default WebsiteUrl;
